import React from 'react';
import {Col, Container, Nav, Row, Tab} from "react-bootstrap";

function Revolutionindustries(props) {
    return (
        <section className="tekgrip_section tekrevol_dark_bg p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={10} lg={10} xl={10} xxl={10}>
                        <div className="example" data-text="Omnichannel">
                            <h2>Omnichannel Retail Software For Unparalleled Experience</h2>
                        </div>
                        <p
                            className="main_para">Our attention to detail and UX-centric development approach helps
                            businesses enhance productivity and manage inventory, logistics, and customers ceaselessly,
                            like never before! </p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="tekgrip_tabs">
                        <Tab.Container defaultActiveKey="0">
                            <Row>
                                <Col xs={12} md={6} lg={6} xl={6}>
                                    <Nav variant="pills" className="flex-column">
                                        <Nav.Item>
                                            <Nav.Link eventKey="0">Simplified Retail Operations</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="1">Dashboard Analytics</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="2">B2B Retail Marketplaces</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="3">Mobile Retail Solutions</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="4">Virtual Retail Storefronts</Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Col>
                                <Col xs={12} md={6} lg={6} xl={6} className="my-auto">
                                    <Tab.Content>
                                        <Tab.Pane eventKey="0">
                                            <p>Our retail software solutions help clients streamline all their retail
                                                operations, including inventory management, vendor management, customer
                                                management, logistics and supply chain management, order management,
                                                returns and exchange, billing and POS, and much more!</p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="1">
                                            <p>Our POS and dashboard analytics features help clients conduct detailed
                                                analyses and get data-driven insights to improve operational efficiency
                                                using artificial intelligence. With dashboard analytics, clients can get
                                                instant insights into the inventory and the performance of each
                                                product. </p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="2">
                                            <p>We build customized, feature-rich B2B retail marketplaces to help our
                                                clients connect with global vendors and retailers. Our B2B retail
                                                marketplaces are packed with class-apart features like one-click
                                                add-to-cart, advanced search filters, and multiple payment gateways to
                                                deliver an unparalleled retail experience. </p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="3">
                                            <p>We build full-fledged retail software applications for desktops and
                                                smartphones to enable our clients to manage inventory and logistics
                                                easily. Our mobile retail solutions are as comprehensive as the desktop
                                                versions and can be used on iOS and Android devices. </p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="4">
                                            <p>We help our clients build virtual retail storefronts to enable them to
                                                operate 24/7 without any human assistance. Our virtual storefronts have
                                                all the advanced features like automated inventory updates, order
                                                placement, payment integrations, and delivery and return options to
                                                ensure a seamless user experience. </p>
                                        </Tab.Pane>
                                        

                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>

                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Revolutionindustries;